<template>
  <div class="text-xs-center">
    <v-bottom-sheet full-width v-model="sheet">
      <v-btn @click="requestFullscreen()" color="green" dark slot="activator">
        {{ buttonText }}
      </v-btn>
      <v-layout row wrap>
        <v-flex class="text-xs-center" xs12>
          <v-card>
            <v-card-title class="py-2">
              {{ title }}
              <v-spacer></v-spacer>
              <v-icon @click="sheet = false" color="red" flat>close</v-icon>
            </v-card-title>
            <v-card-text class="py-0 my-0">
              <VueSignaturePad
                class="signaturePad"
                height="60vh"
                ref="signaturePad"
                v-if="this.saving === false"
                width="100%"
              />
              <v-progress-circular
                :size="100"
                :width="10"
                color="primary"
                indeterminate
                v-else
              ></v-progress-circular>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="undo" bottom color="red" dark fab left>
                <v-icon>undo</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn @click="save" bottom color="green" dark fab right>
                <v-icon>save</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-bottom-sheet>
  </div>
</template>
<script>
import Vue from 'vue'
import VueSignaturePad from 'vue-signature-pad'
import { mapActions, mapGetters, mapMutations } from 'vuex'

Vue.use(VueSignaturePad)

export default {
  name: 'MySignaturePad',
  data: () => ({
    sheet: false,
    isFullscreen: false,
    saving: false
  }),
  props: ['buttonText', 'title', 'callId', 'onlyEvent', 'signatureType'],
  mounted() {
    this.$refs.signaturePad.openSignaturePad()
    this.saving = false
  },
  computed: {
    ...mapGetters({
      activeCallId: 'calls/activeCallId'
    })
  },
  methods: {
    ...mapActions({
      addMedia: 'calls/addMedia',
      updateSignature: 'calls/updateSignature'
    }),
    ...mapMutations({
      setNotification: 'root/SET_NOTIFICATION'
    }),
    undo() {
      this.$refs.signaturePad.clearSignature()
    },
    close() {
      this.sheet = false
    },
    save() {
      this.saving = true
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      if (!isEmpty) {
        const media = {}
        media.src = data
        media.type = 'signature'
        const p = {
          callId: this.callId,
          src: data,
          type: this.signatureType || ''
        }
        if (this.onlyEvent === true) {
          // Only event is existing, so we are emitting event with signature and care about it in parent component
          this.updateSignature(p)
          this.$emit('signature-updated', p)
          this.sheet = false
          this.saving = false
        } else {
          // Save as media
          this.addMedia({
            id: this.activeCallId,
            media: media,
            params: { collection: 'signature' }
          }).then(r => {
            this.setNotification(
              this.$vuetify.t('$vuetify.calls.signatureSaved')
            )
            this.close()
            this.updateSignature(p)
            this.$emit('signature-updated', p)
            // this.$refs.signaturePad.clearSignature()
            this.sheet = false
            this.saving = false
          })
        }
      } else {
        this.setNotification(this.$vuetify.t('$vuetify.calls.signatureEmpty'))
      }
    },
    requestFullscreen() {
      if (!this.isFullscreen && process.env.VUE_APP_ENV != 'local') {
        const elem = document.documentElement
        if (
          document.fullscreenEnabled ||
          document.webkitFullscreenEnabled ||
          document.mozFullScreenEnabled ||
          document.msFullscreenEnabled
        ) {
          if (elem.requestFullscreen) {
            elem.requestFullscreen()
            this.isFullscreen = true
          } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen()
            this.isFullscreen = true
          } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen()
            this.isFullscreen = true
          } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen()
            this.isFullscreen = true
          }
        }
      }
    }
  },
  watch: {
    sheet: function() {
      // const lockOrientation = screen.lockOrientation || screen.mozLockOrientation || screen.msLockOrientation || screen.orientation.lock
      if (this.sheet === true) {
        screen.orientation.lock('landscape').catch(function(error) {
          // whatever
          console.log('Landscape error', error)
        })
      } else {
        screen.orientation.lock('natural').catch(function(error) {
          // whatever
          console.log('Natural error', error)
        })
      }
    }
  }
}
</script>
<style scoped>
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100% !important;
}

.signaturePad {
  border: 1px solid #cccccc;
}
</style>
